var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-task-info"},[_c('div',{staticClass:"table-no"},[_vm._v("\n    "+_vm._s(_vm.$t('kdu.table'))+"\n    "),_c('b',[_vm._v(_vm._s(_vm.table.table_no))])]),_c('div',{staticClass:"order-no"},[_vm._v(_vm._s(_vm.$t('kdu.orderNo'))+": # "+_vm._s(_vm.table.order_no))])])
}
var staticRenderFns = []

export { render, staticRenderFns }